import {Component, OnInit, ViewChild} from '@angular/core';
import {CatalogState, CatalogVersions} from "../../../store/catalog/catalog.state";
import {NzTableComponent} from "ng-zorro-antd/table";


@Component({
    selector: 'app-catalogs',
    templateUrl: './catalogs.component.html',
    styleUrls: ['./catalogs.component.scss'],
    standalone: false
})
export class CatalogsComponent implements OnInit{
  @ViewChild(NzTableComponent, { static: true }) table!: NzTableComponent<CatalogVersions>;

  constructor(public state : CatalogState) {
  }

  ngOnInit(): void {
    this.state.getAll();
  }
}
